/* eslint-disable no-case-declarations, no-param-reassign */
import _ from 'lodash';

import * as types from '../action.types';

export const initialState = {
  lastInsertedId: 0,
  rules: {},
};

const RuleReducer = (state = initialState, action) => {
  let newId = state.lastInsertedId;

  switch (action.type) {
    case types.FETCH_SESSION_SUCCESS:
    case types.CREATE_JOIN_ITEM:
      const rules = _.reduce(action.payload.rules, (result, rule) => {
        newId += 1;

        result[newId] = {
          id: newId,
          ...rule,
        };

        return result;
      }, action.type === types.CREATE_JOIN_ITEM ? { ...state.rules } : {});

      return {
        lastInsertedId: newId,
        rules: {
          ...rules,
        },
      };

    case types.CREATE_NEW_RULE:
      newId += 1;
      const index =
        _.filter(state.rules, rule => rule.attribute === action.payload.attribute).length;

      return {
        lastInsertedId: newId,
        rules: {
          ...state.rules,
          [newId]: {
            id: newId,
            ...action.payload,
            active: true,
            index,
          },
        },
      };

    case types.UPDATE_RULE_ORDER:

      return {
        lastInsertedId: state.lastInsertedId,
        rules: {
          ...state.rules,
          ..._.mapKeys(action.payload, 'id'),
        },
      };

    case types.UPDATE_RULE_ACTIVE:
      return {
        lastInsertedId: state.lastInsertedId,
        rules: _.forEach(state.rules,(rule) => {
          if(rule.id === action.payload.id){
            rule.active = action.payload.active;
          }
        })

      }
    case types.UPDATE_RULE:
      return {
        lastInsertedId: state.lastInsertedId,
        rules: _.forEach(state.rules, (rule) => {
          if(rule.id === action.payload.id){
            rule.text = action.payload.text;
          }
        })
      }
    case types.DELETE_RULE:
      return {
        ...state,
        rules: _.omit(state.rules, action.payload),
      };

    case types.DELETE_METADATA_ITEM:
      return {
        ...state,
        rules: _.reduce(state.rules, (result, rule) => {
          if (rule.attribute !== action.payload) {
            result[rule.id] = rule;
          }

          return result;
        }, {}),
      };

    case types.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default RuleReducer;
